import { Route, Routes } from "react-router-dom";
import Home from "../pages/Home/index";
import About from "../pages/About/Index";
import Contact from "../pages/Contact/Index"; 

export default function Index() {
  return (

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/contact" element={<Contact />} />
      </Routes>

  );
}